import React, { Suspense, useMemo, useState } from 'react';

import { Button, Space } from 'antd';
import { useDispatch } from 'dva';

import EyeFilled from '@/assets/icons/eye_filled.svg';
import DownloadFileOutlined from '@/assets/icons/download_file_outlined.svg';
import { encodeFileUrl } from '@/utils/infrastructure/file-system';
import styles from '../style.less';

const FileDetailsDrawer = React.lazy(() => import('@/components/Common/FileDetailsDrawer'));

const ImagePreview = ({ item, editGridMode }) => {
  const dispatch = useDispatch();
  const [detailsFile, setDetailsFile] = useState(null);

  const { previewUrl, downloadUrl } = useMemo(() => {
    if (!item) return { previewUrl: null, downloadUrl: null };

    if (item.isBase64) {
      const raw = item.previewUrl ?? item.downloadUrl;
      if (!raw) return { previewUrl: null, downloadUrl: null };
      if (typeof raw === 'string' && (raw.startsWith('data:') || /^https?:/i.test(raw))) {
        return { previewUrl: raw, downloadUrl: raw };
      }
      const dataUrl = `data:${item.contentType || 'image/png'};base64,${raw}`;
      return { previewUrl: dataUrl, downloadUrl: dataUrl };
    }

    const url = item.previewUrl ?? item.downloadUrl;
    const safe = url && !/^data:/i.test(url) ? encodeFileUrl(url) : url;
    return { previewUrl: safe, downloadUrl: safe };
  }, [item]);

  const handleDownload = () => {
    dispatch({
      type: 'global/directDownload',
      payload: { ...item, downloadUrl },
    });
  };

  const handlePreview = () => {
    setDetailsFile({
      ...item,
      downloadUrl,
      previewUrl,
      isBase64: item.isBase64,
      content: item.isBase64 ? item.previewUrl ?? item.downloadUrl : undefined,
    });
  };

  if (!previewUrl) return null;

  return (
    <>
      <div
        className={styles.rowImagePreview}
        style={{ backgroundImage: `url("${previewUrl}")` }}
        role="img"
        aria-label={item.fileName || 'preview'}
      >
        {!editGridMode && (
          <div>
            <Space size={6}>
              <Button
                type="primary"
                size="small"
                icon={<img alt="" src={EyeFilled} />}
                onClick={handlePreview}
              />
              <Button
                type="primary"
                size="small"
                icon={<img alt="" src={DownloadFileOutlined} />}
                onClick={handleDownload}
              />
            </Space>
          </div>
        )}
      </div>

      {detailsFile ? (
        <Suspense fallback={null}>
          <FileDetailsDrawer file={detailsFile} onClose={() => setDetailsFile(null)} />
        </Suspense>
      ) : null}
    </>
  );
};

export default ImagePreview;
